<app-data-table [showMenu]="false" class="w-100" [columnList]="listOfColumn" [dataSet]="taxonomyList" [optionList]="optionList"
  [defaultSortBy]="listOfColumn[3]" [isConfigurable]="true" [selectedOptionList]="defaultFilterOptions" [showResetFilter]="true"
  (pageChangeEvent)="getChanges($event)" (linkClicked)="onTaxonomySelected($event)">
</app-data-table>